'use client';

import Script from 'next/script';

import { env } from '@/env/env';
import { isSSR } from '@/utils/helper';
import { CONSENT_STORAGE_KEY } from '@/events/core/consent';

export const GtagScript = () => {

    if (isSSR) {
        return null;
    }

    return (
        <Script id="gtag">
            {`
            window.dataLayer = window.dataLayer || [];
            function gtag() {window.dataLayer.push(arguments);}

            // WE-115 Consent Mode v2: default to denied for everyone until the
            // consent banner records a choice, so GTM/GA4/Meta tags gated on
            // these signals don't fire before consent. Read any prior choice
            // synchronously (same key as src/events/core/consent.ts) so a
            // returning consenting user doesn't flash denied->granted.
            (function() {
                var stored;
                try { stored = window.localStorage.getItem('${CONSENT_STORAGE_KEY}'); } catch (e) {}
                var state = stored === 'granted' ? 'granted' : 'denied';
                gtag('consent', 'default', {
                    ad_storage: state,
                    analytics_storage: state,
                    ad_user_data: state,
                    ad_personalization: state,
                    wait_for_update: 500
                });
            })();

            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl${env('NEXT_PUBLIC_GTAG_EXTRA') ?? ''};f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${env('NEXT_PUBLIC_GTAG_ID')}');

            gtag('js', new Date());
        `}
        </Script>
    );
};
